import Vue from 'vue'
import Router from 'vue-router'
const SHOW_FUTURE = process.env.VUE_APP_SHOW_FUTURE === 'true'

const Dashboard = () => import('Views/Dashboard')
const Catalog = () => import('Views/Catalog')
const SignUp = () => import('Views/session/SignUp')
const POCSetup = () => import('Views/session/POCSetup')
const Login = () => import('Views/session/Login')
const AuthCallback = () => import('Views/session/AuthCallback')
const ResetPassword = () => import('Views/session/ResetPassword')
const NewPassword = () => import('Views/session/NewPassword')
const ProfileEditor = () => import('Views/ProfileEditor')
const Discovery = () => import('Views/Discovery')
const PartnerPortal = () => import('Views/PartnerPortal')
const Scans = () => import('Views/Scans')
const LogoutChart = () => import('Views/LogoutChart')
const Scheduling = () => import('Views/Scheduling')
const BillingNew = () => import('Views/BillingNew')
const Billing = () => import('Views/Billing')
const Eula = () => import('Views/Eula')

const ApiKeyEditor = () => import('@/components/ApiKey/Api_keyEditor')
const CollectorEditor = () => import('@/components/Collector/CollectorEditor')
const SettingsComponent = () => import('@/components/settings/Settings')
const SettingsProfileComponent = () => import('@/components/settings/profile/Profile')
const SettingsNotificationsComponent = () => import('@/components/settings/notifications/Notifications')
const SettingsSecurityComponent = () => import('@/components/settings/security/Security')
const SettingsDefaultsComponent = () => import('@/components/settings/defaults/Defaults')
const SettingsTicketsComponent = () => import('@/components/settings/tickets/Tickets')
const SettingsPrivacyComponent = () => import('@/components/settings/privacy/Privacy')
const SettingsCostPerRecordStudyComponent = () => import('@/components/settings/cost-per-record-study/CostPerRecordStudy')
const SettingsCostPerRecordStudyEditorComponent = () => import('@/components/settings/cost-per-record-study/CostPerRecordStudyEditor')
const SettingsCyberSecurityAssessmentComponent = () => import('@/components/settings/cyber-security-assessment/CyberSecurityAssessment')
const SettingsCyberSecurityAssessmentEditorComponent = () => import('@/components/settings/cyber-security-assessment/CyberSecurityAssessmentEditor')
const SettingsUsersTeamsComponent = () => import('@/components/settings/users-teams/UsersTeams')
const ExportsAudit = () => import('@/components/settings/exports-audit/ExportsAudit')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/partner-portal',
      name: 'partner-portal',
      component: PartnerPortal,
      meta: {
        requiresAuth: true,
        title: 'Partner Portal',
        authorize: ['owner', 'admin', 'viewer']
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        title: 'Dashboard',
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/catalog',
      name: 'catalog',
      component: Catalog,
      props: (route) => ({ query: route.query }),
      meta: {
        requiresAuth: true,
        title: 'Catalog',
        authorize: ['owner', 'admin', 'viewer']
      }
    },
    {
      path: '/scans',
      name: 'scans',
      component: Scans,
      props: (route) => ({ query: route.query }),
      meta: {
        requiresAuth: true,
        title: 'Scans',
        authorize: ['owner', 'admin', 'viewer']
      }
    },
    {
      path: '/session/signup',
      name: 'signup',
      component: SignUp,
      meta: {
        hideNavigation: true,
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/session/login',
      name: 'login',
      component: Login,
      meta: {
        hideNavigation: true,
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/session/reset-password',
      name: 'reset-password',
      component: ResetPassword,
      meta: {
        hideNavigation: true,
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/session/new-password',
      name: 'new-password',
      component: NewPassword,
      meta: {
        hideNavigation: true,
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/session/poc-setup',
      name: 'poc-setup',
      component: POCSetup,
      meta: {
        hideNavigation: true,
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/callback',
      name: 'auth-callback',
      component: AuthCallback,
      meta: {
        hideNavigation: true
      }
    },
    {
      path: '/editprofile',
      name: 'editprofile',
      component: ProfileEditor,
      meta: {
        requiresAuth: true,
        title: 'Edit Profile',
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/discovery',
      name: 'discovery',
      component: Discovery,
      meta: {
        requiresAuth: true,
        title: 'Discovery',
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/discovery/histogram',
      name: 'histogram',
      component: Discovery,
      meta: {
        requiresAuth: true,
        title: 'Discovery',
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/discovery/stackedArea',
      name: 'stackedArea',
      component: Discovery,
      meta: {
        requiresAuth: true,
        title: 'Discovery',
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/scheduling',
      name: 'scheduling',
      component: Scheduling,
      meta: {
        requiresAuth: true,
        title: 'Scheduling',
        authorize: ['owner', 'admin']
      }
    },
    {
      path: '/logoutchart',
      name: 'logoutchart',
      component: LogoutChart,
      meta: {
        requiresAuth: true,
        title: 'Logout Chart',
        authorize: ['owner', 'admin', 'viewer']
      }
    },
    {
      path: '/billing',
      name: 'billing',
      component: SHOW_FUTURE ? BillingNew : Billing,
      meta: {
        requiresAuth: true,
        title: 'Billing',
        authorize: ['owner']
      }
    },
    {
      path: '/eula',
      name: 'eula',
      component: Eula,
      meta: {
        requiresAuth: true,
        hideNavigation: true,
        title: 'Eula',
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/auth/callback/:provider',
      name: 'auth_callback',
      component: AuthCallback,
      meta: {
        requiresAuth: true,
        hideNavigation: true,
        title: 'Authenticating...',
        authorize: ['owner', 'admin', 'viewer', 'guest']
      }
    },
    {
      path: '/api_keyeditor/:id',
      name: 'api_keyeditor',
      component: ApiKeyEditor,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'ApiKeyEditor',
        authorize: ['owner', 'admin', 'viewer']
      }
    },
    {
      path: '/collectoreditor/:id',
      name: 'collectoreditor',
      component: CollectorEditor,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'Collector Editor',
        authorize: ['owner', 'admin', 'viewer']
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      redirect: '/settings/profile',
      component: SettingsComponent,
      meta: {
        requiresAuth: true,
        title: 'Logout Chart',
        authorize: ['owner', 'admin', 'viewer']
      },
      children: [
        {
          path: '/settings/profile',
          name: 'SettingsProfile',
          component: SettingsProfileComponent,
          meta: {
            requiresAuth: true,
            title: 'Profile & Basic Info',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/notifications',
          name: 'SettingsNotifications',
          component: SettingsNotificationsComponent,
          meta: {
            requiresAuth: true,
            title: 'Notifications',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/security',
          name: 'SettingsSecurity',
          component: SettingsSecurityComponent,
          meta: {
            requiresAuth: true,
            title: 'Security',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/defaults',
          name: 'SettingsDefaults',
          component: SettingsDefaultsComponent,
          meta: {
            requiresAuth: true,
            title: 'Account Defaults',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/tickets',
          name: 'SettingsTickets',
          component: SettingsTicketsComponent,
          meta: {
            requiresAuth: true,
            title: 'Tickets & Supports',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/privacy',
          name: 'SettingsPrivacy',
          component: SettingsPrivacyComponent,
          meta: {
            requiresAuth: true,
            title: 'Privacy Policy',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/cost-per-record-study',
          name: 'SettingsCostPerRecordStudy',
          component: SettingsCostPerRecordStudyComponent,
          meta: {
            requiresAuth: true,
            title: 'Cost Per Record',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/cost-per-record-study/edit/:id',
          name: 'SettingsCostPerRecordStudyEditor',
          component: SettingsCostPerRecordStudyEditorComponent,
          props: true,
          meta: {
            requiresAuth: true,
            title: 'Add/Edit Cost Per Record',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/cyber-security-assessment',
          name: 'SettingsCyberSecurityAssessment',
          component: SettingsCyberSecurityAssessmentComponent,
          meta: {
            requiresAuth: true,
            title: 'Cyber Security Assessment',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/cyber-security-assessment/edit/:id',
          name: 'SettingsCyberSecurityAssessmentEditor',
          component: SettingsCyberSecurityAssessmentEditorComponent,
          props: true,
          meta: {
            requiresAuth: true,
            title: 'Add/Edit Cyber Security Assessment',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/users-teams',
          name: 'SettingsUsersTeams',
          component: SettingsUsersTeamsComponent,
          meta: {
            requiresAuth: true,
            title: 'Users & Teams',
            authorize: ['owner', 'admin', 'viewer']
          }
        },
        {
          path: '/settings/exports-audit',
          name: 'ExportsAudit',
          component: ExportsAudit,
          meta: {
            requiresAuth: true,
            title: 'Exports Audit',
            authorize: ['owner', 'admin']
          }
        }
      ]
    },
    { path: '*', redirect: '/' }
  ],
  scrollBehavior (to, from, savedPosition) {
    let position = { x: 0, y: 0 }
    // Keep scroll position when using browser buttons
    if (savedPosition) {
      position = savedPosition
    }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(position)
      }, 300)
    })
  }
})

const req = require.context('../views/categories', true, /\.(vue)$/i)

const allCategoriesFiles = req.keys().map(key => {
  const name = key.match(/\w+/)[0]
  return Vue.component(name, req(key))
})
for (let i = 0; i < allCategoriesFiles.length; i++) {
  if (!allCategoriesFiles[i].default.name.toLowerCase().includes('editor')) {
    const category = {
      path: `/${allCategoriesFiles[i].default.name.toLowerCase()}`,
      name: `${allCategoriesFiles[i].default.name.toLowerCase()}`,
      component: allCategoriesFiles[i].default,
      meta: {
        requiresAuth: true,
        title: `${allCategoriesFiles[i].default.name}`,
        authorize: ['owner', 'admin']
      }
    }
    router.addRoute(category)
  }
}

const allEditorsFiles = req.keys().map(key => {
  const name = key.match(/\w+/)[0]
  return Vue.component(name, req(key))
})
for (let i = 0; i < allEditorsFiles.length; i++) {
  if (allEditorsFiles[i].default.name.toLowerCase().includes('editor')) {
    const category = {
      path: `/${allEditorsFiles[i].default.name.toLowerCase()}/:id`,
      name: `${allEditorsFiles[i].default.name.toLowerCase()}`,
      component: allEditorsFiles[i].default,
      props: true,
      meta: {
        requiresAuth: true,
        title: `${allEditorsFiles[i].default.name}`,
        authorize: ['owner', 'admin']
      }
    }
    router.addRoute(category)
  }
}

// addRoutes is DEPRECATED use addRoute instead
// router.addRoutes(categories)

export default router
